import { Row } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import Container from "../../common/Container";
import {
  FooterSection,
  NavLink,
  Extra,
  Large,
  Language,
} from "./styles";

const Footer = ({ t }: { t: TFunction }) => {
  return (
    <>
      <FooterSection>
        <Container>
              <Language>{t("Contact")}</Language>
              <p>{"mob: +385 91 501 1822"}</p>
              <p>{"mail: aleafelixgambit@gmail.com"}</p>
        </Container>
      </FooterSection>
      <Extra>
        <Container border={true}>
          <Row
            justify="space-between"
            align="middle"
            style={{ paddingTop: "3rem" }}
          >
            <NavLink to="/">
            <Large to="/">{"Alea Felix Gambit d.o.o."}</Large>

            </NavLink>
          </Row>
        </Container>
      </Extra>
    </>
  );
};

export default withTranslation()(Footer);
